import React, { useEffect, useRef, useState } from "react";

import { motion, AnimatePresence } from "motion/react";

export const StatListItem = ({ rank, type, data }) => {
  var title = "";
  var subtitle = "";
  var artwork = "";
  var listenCount = "";

  if (type == "artists" && data.artist_id) {
    title = data.artist_id.name;
    subtitle = data.play_count + " listens";
    artwork = data.artist_id.artwork;
    listenCount = data.play_count;
  } else if (type == "albums" && data.album_id) {
    title = data.album_id.name;
    subtitle = data.album_id.artistName;
    artwork = data.album_id.artwork;
    listenCount = data.play_count;
  } else if (type == "songs" && data.song_id) {
    title = data.song_id.name;
    subtitle = data.song_id.artistName;
    artwork = data.song_id.artwork;
    listenCount = data.play_count;
  } else if (type == "genres" && data.genre) {
    title = data.genre;
    subtitle = data.minutes + " minutes · " + data.play_count + " tracks";
    artwork = null;
    listenCount = null;
  }

  return (
    <motion.div
      className="row-layout list-item"
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
      }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 1.0,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className={"cover-and-rank cover-and-rank-" + type}>
        <p className="rank-decoration">{rank}</p>
        {type != "artists" && artwork && (
          <img className="list-cover-image" src={artwork} />
        )}
        {type == "artists" && artwork && (
          <img
            referrerPolicy="no-referrer"
            className="artist-capsule list-cover-artist"
            src={artwork}
          />
        )}
      </div>

      {type != "artists" && title && (
        <div className="column-layout">
          <p className={"list-title list-title-" + type}>{title}</p>
          <p className="list-subtitle">{subtitle}</p>
        </div>
      )}

      {type == "artists" && title && (
        <div className="column-layout">
          <p className={"list-title list-title-" + type}>{title}</p>
          <p className="list-subtitle">{subtitle}</p>
        </div>
      )}
    </motion.div>
  );
};
